export enum ParkingType {
	PRIVATE_GARAGE = 'PRIVATE_GARAGE',
	PRIVATE_OUTDOOR_PARKING = 'PRIVATE_OUTDOOR_PARKING',
	DO_NOT_HAVE = 'DO_NOT_HAVE',
	OTHER = 'OTHER',
}
